$(document).ready(function() {

/**box selection step**/
$('body').on('click', '.step_boxes .box_itemcard', function(){
$('.box_itemcard').each(function(){
$(this).removeClass('active-step');
});
$(this).addClass('active-step');
var boxtype = $(this).attr('data-boxtype');
$('.addToCartbox').attr('data-box', boxtype);
//console.log('boxtype === ', boxtype);
var newprice = $(this).attr('data-boxprc')
$('.price_b').text(newprice);
});

/**protein selection step**/
const maximums = 3;
const minimums = 1;
let selectedqty = 0;
let protein_names = [];
//Note: a single protein is is added only 1 time. 
$('body').on('click', '.step_proteins .protein_item .imageprotein', function(){

if($(this).parent().hasClass('active-protein')){
$(this).parent().removeClass('active-protein');
selectedqty--;
var proteinname = $(this).attr('data-protein');
var index = protein_names.indexOf(proteinname);
if (index > -1) { // only splice array when item is found
  protein_names.splice(index, 1); // 2nd parameter means remove one item only
}
$(this).next().next().show();  //hide add btn
$(this).next().next().next().hide(); //show remove btn
//console.log('protein === ', selectedqty);
}else{

if(protein_names.length < 3){
$(this).parent().addClass('active-protein');
var proteinname = $(this).attr('data-protein');
selectedqty++;
protein_names.push(proteinname);
$(this).next().next().hide();  //hide add btn
$(this).next().next().next().show(); //show remove btn
//console.log('protein === ', selectedqty);
//console.log('protein_names === ', protein_names); 
}
  
}


if(protein_names.length == 0){
$('.addToCartbox').attr('disabled', true);
}else{
  $('.addToCartbox').removeAttr('disabled');
}


if(protein_names.length == 3){
$('.protein_item').each(function(){
if($(this).hasClass('active-protein')){
 //do nothing
}else{
  $(this).addClass('disabled-me')
}  
});

}else{
$('.protein_item').each(function(){
 $(this).removeClass('disabled-me') 
});
}

});

  //when click onn add btn
$('body').on('click', '.step_proteins .protein_addbtn', function(){
if(protein_names.length < 3){
$(this).parent().addClass('active-protein');
var proteinname = $(this).attr('data-protein');
selectedqty++;
protein_names.push(proteinname);
$(this).hide();  //hide add btn
$(this).next().show(); //show remove btn
//console.log('protein === ', selectedqty);
//console.log('protein_names === ', protein_names); 
}
  
if(protein_names.length == 0){
$('.addToCartbox').attr('disabled', true);
}else{
  $('.addToCartbox').removeAttr('disabled');
}

if(protein_names.length == 3){
$('.protein_item').each(function(){
if($(this).hasClass('active-protein')){
 //do nothing
}else{
  $(this).addClass('disabled-me')
}  
});

}else{
$('.protein_item').each(function(){
 $(this).removeClass('disabled-me') 
});
}
  
});

  //when click onn remove btn
$('body').on('click', '.step_proteins .protein_removebtn', function(){
$(this).parent().removeClass('active-protein');
selectedqty--;
var proteinname = $(this).attr('data-protein');
var index = protein_names.indexOf(proteinname);
if (index > -1) { // only splice array when item is found
  protein_names.splice(index, 1); // 2nd parameter means remove one item only
}
$(this).hide();  //hide add btn
$(this).prev().show(); //show remove btn
//console.log('protein === ', selectedqty);
//console.log('protein_names === ', protein_names); 

if(protein_names.length == 0){
$('.addToCartbox').attr('disabled', true);
}else{
  $('.addToCartbox').removeAttr('disabled');
}

if(protein_names.length == 3){
$('.protein_item').each(function(){
if($(this).hasClass('active-protein')){
 //do nothing
}else{
  $(this).addClass('disabled-me')
}  
});

}else{
$('.protein_item').each(function(){
 $(this).removeClass('disabled-me') 
});
}
  
});


const stickyClass = 'sticky';
const offsetFromBottom = 400; // Change this value to determine how close to the bottom the user must be before removing the class

$(window).on('scroll', function() {
if ($(window).scrollTop() + $(window).height() > $(document).height() - offsetFromBottom) {
    $('.boxfooters').removeClass(stickyClass);
} else {
    $('.boxfooters').addClass(stickyClass);
}
});

/***Add to cart code***/
recharge.init({
// This should be your myshopify.com domain
storeIdentifier: '{{shop.permanent_domain}}',
appName: 'appName',
appVersion: '1.0.0',
});

  document.getElementById('addToCartbox').addEventListener('click', async () => {
    $('#addToCartbox').text('Adding...');
    var boxtyp = $('#addToCartbox').attr('data-box'); // Regular Or Large
    var variantops = boxtyp +' '+ selectedqty;  //variantops which mathed with select#product-variant-list value get that data-id  
    var matchedOption = $('#product-variant-list option').filter(function() {
        return $(this).val() === variantops;
    });
     var dataId = '';
    if (matchedOption.length) {
        dataId = matchedOption.data('id');
        console.log('Matched data-id:', dataId);
    } else {
        console.log('No matching variant found');
    }

var selectedValue = $('#selling-plan-list').val();
console.log('Selected value:', selectedValue);
    const bundleProductData = {
      variantId: dataId,  //regular id
      productId: '7576730468451',  //product id
      sellingPlan: selectedValue
    }
console.log(bundleProductData);
var formattedProteins = '';
protein_names.forEach(function(protein) {
    formattedProteins += '1x ' + protein + '\n';
});
formattedProteins = formattedProteins.trim(); // Remove the last newline character
console.log(formattedProteins);

    // This creates the bundle object containing the selections
    // we'll pass this object to `getBundleId`.
    const bundle = {
      "externalVariantId": bundleProductData.variantId,
      "externalProductId": bundleProductData.productId
      , "selections": [
        {
          "collectionId": "275632914531",   //protein collection
          "externalProductId": "7329221902435",   //beef product
          "externalVariantId": "41722794115171",   // beef 1st var id
          "quantity": 1
        }
        ,{
          "collectionId": "275632914531",   // protein collection
          "externalProductId": "7329208598627",  //chicken product
          "externalVariantId": "41722717896803", // chicken 1st var id
          "quantity": 1
        }
      ]
    };
  
    const rbId = await recharge.bundle.getBundleId(bundle);
    // Adds the value directly to the cart
    const cartData = {
      items: [{
        id: bundleProductData.variantId,
        quantity: 1,
        selling_plan: bundleProductData.sellingPlan,
        properties: { 
		 Contents: formattedProteins,
		_rb_id: rbId 
		},
      }]
    };
	//console.log('test' , cartData);
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData),
    });
   $('#addToCartbox').text('Added');
  //  window.location.href = '/cart';
  });
  
});
